import React, { useContext } from "react";
import { InitDomain } from "src/context/domain/domainContext";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "@amzn/awsui-components-react";

interface Props {
  keyword: string;
  setValue: Function;
  onClickSearch: Function;
}

export const FixedFeeConfigSearchBar: React.FC<Props> = ({
  keyword,
  setValue,
  onClickSearch,
}) => {
  const domainData = useContext(InitDomain);
  const navigate = useNavigate();
  const onClick = () => {
    navigate(`/getfixedfeeconfig/${keyword}`);
    onClickSearch(domainData.domain);
  };
  return (
    <div className="input-container">
      <div className="input-filter">
        <Input
          data-testid="input-filter"
          type="search"
          value={keyword}
          onChange={(e: any) => {
            if (e.detail != null) {
              setValue(e.detail.value.trim());
            }
          }}
          placeholder="Please enter FixedFee ID"
          clearAriaLabel="clear"
          ariaDescribedby={""}
        />
      </div>
      <Button onClick={onClick}>Get FixedFee Config</Button>
    </div>
  );
};
